import { facilityImages } from "../../models/site";
import { ImageGallery } from "../ImageGallery";
import { PageIntro } from "./PageIntro";

const facilityCopy = [
  {
    title: "基本設施",
    en: "AMENITIES",
    text: [
      "全館免費 WiFi Free WiFi",
      "洗衣機 NT$50 / 次 Washing machine",
      "行李寄放 Luggage storage",
      "免費腳踏車 Free bicycles",
      "全區使用軟水 Whole-Building Soft Water System",
    ],
  },
  {
    title: "公共空間",
    en: "COMMON AREA",
    text: [
      "室內交誼廳 Indoor lounge",
      "半戶外庭院 Semi-outdoor patio",
      "觀景天台 Rooftop with mountain and sea views",
    ],
  },
  {
    title: "共用廚房",
    en: "KITCHEN",
    text: [
      "飲水機 Water dispenser",
      "共用冰箱 Shared refrigerator",
      "免費茶包 Tea",
      "瓦斯爐、烤箱、微波爐 Gas stove, toaster & microwave",
      "基本鍋具與餐具 Cookware & tableware",
    ],
  },
];

export function FacilitiesPage() {
  return (
    <div className="standard-page">
      <PageIntro eyebrow="MAKE YOURSELF AT HOME" title="設施" en="FACILITIES" />
      <div className="facility-copy-grid">
        {facilityCopy.map((item) => (
          <article key={item.en}>
            <p className="eyebrow">{item.en}</p>
            <h2>{item.title}</h2>
            <ul>
              {item.text.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
      <ImageGallery
        images={facilityImages}
        dialogLabel="設施圖片燈箱 Facilities gallery"
        eagerCount={2}
      />
    </div>
  );
}
